import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { ZipCodeFloridaRoutingModule } from './zip-code-florida.routing.module';
import { CreateComponent } from './components/create/create.component';
import { ZipCodeFloridaComponent } from './zip-code-florida.component';
import { ZipCodeFloridaService } from './zip-code-florida.service';
import { Trip2ThemeModule } from '../../trip2-theme/trip2-theme.module';
import { T2AutoCompleteLocationModule } from '../A2-utils/t2-autocomplete-location/t2-autocomplete-location.module';
import { BooleanCheckComponent } from '../A2-utils/grid-components/boolean-check/boolean-check.component';
import { GridComponentsModule } from '../A2-utils/grid-components/grid-components.module';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  imports: [
    AgGridModule.withComponents([BooleanCheckComponent]),
    GridComponentsModule,
    CommonModule,
    ZipCodeFloridaRoutingModule,
    FormsModule,
    Trip2ThemeModule,
    T2AutoCompleteLocationModule,
    DirectivesModule
  ],
  declarations: [CreateComponent, ZipCodeFloridaComponent],
  providers: [ZipCodeFloridaService]
})
export class ZipCodeFloridaModule { }



// WEBPACK FOOTER //
// ./src/app/pages/zip-code-florida/zip-code-florida.module.ts